import React, {useState, useEffect} from 'react';
import ActionItemAssignMember from './ActionItemAssignMember.mjs';
import './ActionItemAssign.css';
import { useCTAL } from './CTAL_Hooks.js';

export default function ActionItemAssign({action_item, assign_prefix}) 
{
    const { app_user, team_members_list, action_item_display_refresh, setActionItemTeamListRefresh } = useCTAL();
    
    const [error, setError]     = useState();
    const [assignee_changed_flag, setAssigneeChangedFlag] = useState(false);
    const [assign_button_type, setAssignButtonType] = useState("btn btn-secondary");

    useEffect(() =>
    {
        setAssigneeChangedFlag(false);
        setAssignButtonType("btn btn-secondary");
    }, [action_item, action_item_display_refresh]);

    //Note: Team Members List is set by Team bulk pull so it's not going to be present for Short and Long List Actions 
    if (team_members_list.length == 0)
        return;

    var local_assign_prefix = assign_prefix;
    if (assign_prefix == undefined)
        local_assign_prefix = "local";

    const local_reset = () => { 
        setAssigneeChangedFlag(false);
        setAssignButtonType("btn btn-secondary");
    }

    const update_action_item = (upd_body) => { 
        local_reset();
        console.log(`ActionItemAssign - Update Action Item upd_body: ${upd_body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: upd_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: upd_body })
            .then(() => setActionItemTeamListRefresh(true))
            .catch(setError);
    }
    
    const assign_member = () => { 
        var assign_input = document.getElementById(local_assign_prefix + "-assign");

        if (assign_input.value.length < 3) return;

        var option_values = assign_input.value.split("-");

        if (option_values.length == 0) return;

        var member = team_members_list[option_values[0]];
        
        if (!member) return;

        var type = "assign_action_item";
        var action_item_id = action_item.ActionItemID;
        var action_user_id = app_user.UserID;
        var action_user_full_name = app_user.UserFullName;
        var assigned_user_id = member.UserID;
        var body = JSON.stringify({type, action_item_id, action_user_id, action_user_full_name, assigned_user_id});
        update_action_item(body);
    }
    
    const assignee_changed = () => { 
        console.log(`ActionItemAssign*** - assignee_changed`);
        setAssigneeChangedFlag(true);
        setAssignButtonType("btn btn-primary");
    }
    
    return (
        <>
            <div class="input-group input-group-sm">
                <input id={local_assign_prefix + "-assign"} class="form-control" list="datalistOptions"  placeholder="Type to search for Member name..." onChange={assignee_changed}/>
                <button id="button-assign" class={assign_button_type} type="button" onClick={ () => assign_member() }>Assign</button>
                <datalist id="datalistOptions">
                    { team_members_list?.map( (member, i) => ( <ActionItemAssignMember member={member} key={i} ndx={i} /> )) }
                </datalist>    
            </div>    
        </>
    );
}